import { render, staticRenderFns } from "./RegisterOfPayments.vue?vue&type=template&id=5e007ffa&"
import script from "./RegisterOfPayments.vue?vue&type=script&lang=js&"
export * from "./RegisterOfPayments.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOfPayments.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports